import { Navigate } from "react-router-dom";

/**
 * Inverse of AuthGuard: routes that only make sense when logged OUT
 * (login, register, forgot-password). A user who already has a session
 * token is bounced to the dashboard instead of seeing the login screen.
 */
export default function GuestGuard({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem("token");

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
